import { Directive, ElementRef, Input, OnInit } from "@angular/core";

@Directive({
    //TODO Matt Arnold change to bwTextColor
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "[mwTextColor]",
    standalone: false
})
export class TextColorDirective implements OnInit {
  @Input("mwTextColor") textColor: string;
  constructor(private el: ElementRef) {}
  ngOnInit() {
    this.el.nativeElement.style.color = this.textColor;
  }
}
